import { render, staticRenderFns } from "./CasePlanAlimentaire.vue?vue&type=template&id=1d936150&scoped=true&"
import script from "./CasePlanAlimentaire.vue?vue&type=script&lang=js&"
export * from "./CasePlanAlimentaire.vue?vue&type=script&lang=js&"
import style0 from "./CasePlanAlimentaire.vue?vue&type=style&index=0&id=1d936150&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d936150",
  null
  
)

export default component.exports